import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/builds/WeArePublic/wap-app/layouts/default.vue").then(m => m.default || m)),
  error: defineAsyncComponent(() => import("/builds/WeArePublic/wap-app/layouts/error.vue").then(m => m.default || m))
}